import { LogEntryModel } from '../../../models/logentry';

export class LogEntry {
    static readonly type = 'SaveLogEntry';
    constructor(public entry: LogEntryModel) { }
}

export class LogEntrySuccess {
    static readonly type = 'SaveLogEntrySuccess';
    constructor(public payload: any) { }
}

